import { IonContent, IonPage, IonSpinner } from "@ionic/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import AuthenticationService from "../../services/AuthenticationService";
import digitService from "../../services/DigitService";
import { updateUserFromAutoLogin } from "../login/loginSlice";
import APIConfig from "../../services/APIConfig";
import axiosClient from "../../app/axiosConfig";
import { getChat, getChatforVital, updateDocumentToken } from "../tab/tabSlice";
import UserService from "../../services/UserService";
import clevertapLogger from "../../clevertapLogger";
import { markRestrictedSession } from "../../utils/restrictedSession";

function AutoLogin() {
  const history = useHistory();
  const dispatch = useDispatch();
  const initCleverTapProfile = ({ user }) => {
    console.log("inside function", user);
    UserService.getPrimaryTherapy(
      user.patientProfile.id,
      (res) => {
        console.log("inside res");
        clevertapLogger.signUp(user, res);
        clevertapLogger.push("OPEN_APP");
      },
      (err) => {
        console.log("inside error");
        clevertapLogger.signUp(user);
        clevertapLogger.push("OPEN_APP");
      },
    );
  };

  useEffect(() => {
    let url = window.location.search;
    let searchParams = new URLSearchParams(url);
    let redirect = searchParams.get("module");
    console.log("module is ", redirect);
    let pid = searchParams.get("pid");
    let phoneNo = searchParams.get("user_id");
    let token = searchParams.get("idToken");

    let countryCode = searchParams.get("countryCode");
    let utm_os = searchParams.get("utm_os");
    let devicename = searchParams.get("devicename");
    let osversion = searchParams.get("osversion");
    let appversion = searchParams.get("appversion");
    let src = searchParams.get("src");
    if (token) {
      const autoLoginPromise =
        src === "pb"
          ? digitService.digitAutoLoginPB(pid, token)
          : digitService.digitAutoLogin(pid, phoneNo, token, countryCode);

      autoLoginPromise
        .then((res) => {
          const authService = new AuthenticationService();
          const data = res.data;
          let profile = data.user;
          authService.activateLogin(data);
          dispatch(
            updateUserFromAutoLogin({
              user: data.user,
              token: data.token,
            }),
          );
          initCleverTapProfile({ user: data.user });
          dispatch(getChatforVital(data.user.id));
          const devicePayload = {
            device: utm_os,
            deviceName: devicename || "unknown",
            osVersion: osversion || "unknown",
            appVersion: appversion || "unknown",
          };
          digitService
            .registerDevice(phoneNo, pid, devicePayload)
            .catch(() => {});

          const getURL = APIConfig.document.tokenGenerate;
          axiosClient
            .get(getURL)
            .then((res) => {
              dispatch(updateDocumentToken({ data: res.data }));
            })
            .catch((err) => {})
            .finally(() => {
              localStorage.setItem("app_source", src || "");
              // Every autologin entry is a deep link from MLI into one
              // screen, so the tab bar stays hidden for the whole session.
              markRestrictedSession();
              if (redirect === "rewards") {
                clevertapLogger.push("open_reward_point_page");
                history.replace("/rewardPointPage");
              } else if (redirect === "healthBenefits") {
                clevertapLogger.push("open_health_benefits");
                history.replace("/tab/home");
              } else if (redirect === "healthPlan") {
                clevertapLogger.push("open_health_nutrition");
                history.replace(`/health-plan?Nutrition`);
              } else if (redirect === "vitals") {
                clevertapLogger.push("open_vital_chart");
                history.replace("/vitalsChart");
              } else if (redirect === "chat") {
                clevertapLogger.push("open_chat");
                history.replace("/tab/chat");
              } else if (redirect === "meditation") {
                clevertapLogger.push("open_meditation");
                history.replace("/meditation");
              } else if (redirect === "medicine") {
                clevertapLogger.push("open_medicine");
                history.replace("/medicine");
              } else if (redirect === "healthChallenge") {
                clevertapLogger.push("open_health_challenge");
                history.replace("/stepathon");
              } else if (redirect === "doctorConsultation") {
                clevertapLogger.push("open_doctor_consultation");
                history.replace("/navigo?currScreen=1&pageType=4");
              } else if (redirect === "nutritionConsultation") {
                clevertapLogger.push("open_nutrition_consultation");
                history.replace("/navigo?currScreen=1&pageType=2");
              } else if (redirect === "sewa") {
                clevertapLogger.push("open_sewa");
                history.replace("/navigo?currScreen=1&pageType=5");
              } else if (redirect === "labTest") {
                clevertapLogger.push("open_labtest");
                history.replace(
                  "/navigo?currScreen=1&serviceType=2&pageType=3",
                );
              } else if (redirect === "hraOnBot") {
                clevertapLogger.push("open_hraOnBot");
                history.replace("/navigo?currScreen=1&pageType=6");
              } else if (redirect === "documents") {
                clevertapLogger.push("open_documents");
                history.replace("/documents");
              } else if (redirect === "pb-home") {
                clevertapLogger.push("pb_open_home_page");
                history.replace("/pb-home");
              } else if (redirect === "cmp") {
                clevertapLogger.push("open_cmp");
                history.replace("/navigo?currScreen=1&pageType=7");
              } else if (redirect === "secondMedicalOpinion") {
                clevertapLogger.push("open_second_medical_opinion");
                history.replace("/second-medical-opinion");
              } else if (redirect === "assistedMedicalConcierge") {
                clevertapLogger.push("open_assisted_medical_concierge");
                history.replace("/assisted-medical-concierge");
              } else if (redirect === "myAppointments") {
                clevertapLogger.push("open_my_appointments");
                history.replace("/order-history");
              } else {
                history.replace("/tab");
              }
            });
        })
        .catch((err) => {
          //TODO clear cookies as well here
          history.replace("/login");
        });
    } else {
      history.replace("/login");
    }
  }, []);

  return (
    <IonPage>
      <IonContent>
        <div
          style={{
            display: "flex",
            height: "100%",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IonSpinner />
        </div>
      </IonContent>
    </IonPage>
  );
}

export default AutoLogin;
